import { Component } from '@angular/core';
@Component({
	templateUrl: './estoque.component.html',
})

export class EstoqueComponent{
}